export const exterior_view09ImageOptions = {
  angle: 'exterior_view09',
  staticOptions: {
    HullColour: 1,
    HullTreatment: 1,
    BowSpritRailing: 1,
    BowSpritLadder: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    MastAndBoom: 1,
    Sprayhood: 1
  },
  mattes: [
    {
      option: 'HullColour',
      dependency: null
    },
    {
      option: 'Deck',
      dependency: 'Wheel'
    },
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    },
    {
      option: 'TeakOnCoachroof',
      dependency: 'Deck'
    },
    {
      option: 'MastAndBoom',
      dependency: null
    },
    {
      option: 'Sprayhood',
      dependency: 'Deck'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X49MK2/views/exterior_view09.js